
  import { css } from 'lit';
  export const styles = css`igc-textarea::part(input){max-height:9.375rem;padding-block:.6875rem}[part~=dragging] igc-textarea::part(container)::before{box-shadow:inset 0 0 0 .125rem var(--focused-border-color)}`;
  